import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { IBillingShippingModel, SCALOsDetailType, SCALType } from "../../../interfaces/LicenseModel";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";
import Swal from "sweetalert2";

@Component({
    selector:'activate-scal360-license',
    template:require('./activate-scal360-license.component.html'),
    styles:[require('./activate-scal360-license.component.css')]
})
export class ActivateScal360LicenseComponent{
    dialogTitle='Activate SCAL 360 License';
    errorMessage='';
    activateScal360LicenseForm:FormGroup;
    isRadioButtonDisabled=false;
    selectedRow=null;
    billingShippingDetail:IBillingShippingModel={
        ODataEtag:'',
        Number:'',
        publicId:'',
        CustomerNo:'',
        publicSalesPersoncode:'',
        BillToName:'',
        BillToAddress1:'',
        BillToAddress2:'',
        BillToCity:'',
        BillToState:'',
        BillToZipcode:'',
        BillToCountryCode:'',
        ShipToCode:'',
        ShipToName:'',
        ShipToAddress1:'',
        ShipToAddress2:'',
        ShipToCity:'',
        ShipToState:'',
        ShipToZipcode:'',
        ShipToCountryCode:'',
        CustomerTelephone:'',
        CustomerEmailAddress:'',
        CustomerFaxno:'',
        ShippingTelephoneno:'',
        ShippingFaxno:'',
        ShippingEmailAddress:'',
        Rep1:'',
        Rep2:'',
        Sales1:'',
        Sales2:''
    };
    customerId=0;
    shippingAddressId=0;
    shouldFetchSalesOrderNo=false;
    scal360LicenseDisplayList;
    SelectedCustomerLicenseDetail;
    LicenseActivationDetails;
    error="";
    SCALTypeList=[];
    OSDetailList=[];
    SelectedLicenseKey='';
    isLoading=false;
    constructor(
        private dialogRef:MdDialogRef<ActivateScal360LicenseComponent>,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private snackBar:MdSnackBar,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData: any
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList=this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.buildForm();
        Object.keys(SCALOsDetailType).filter((type) => isNaN(Number(type))).forEach((key,index)=>{
            this.OSDetailList.push(key);
        })
        this.getScalCustomerLicenseDetail();
            this.billingShippingDetail.BillToName=this.SelectedCustomerLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1=this.SelectedCustomerLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2=this.SelectedCustomerLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity=this.SelectedCustomerLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName=this.SelectedCustomerLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1=this.SelectedCustomerLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2=this.SelectedCustomerLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity=this.SelectedCustomerLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState=this.SelectedCustomerLicenseDetail.ShipToState;
    }
    buildForm(){
        this.activateScal360LicenseForm=this.formBuilder.group({
            UniqueHardwareId:['',[Validators.required]],
            RequesterName:['',[Validators.required]],
            RequesterEmail:['',[Validators.required]],
            OSDetails:['',[Validators.required]],
            RequesterPhone:['',Validators.required]
        })
    }
    selectRow(selectedLicense,index){
        this.selectedRow=(this.selectedRow==index)?null:index;
        this.SelectedLicenseKey=selectedLicense.LicenseKey
    }
    getScalCustomerLicenseDetail(){
        this.isLoading=true;
        this.licenseService.getScalCustomerLicenseDetailForActivationAndRenewal(this.SelectedCustomerLicenseDetail.LicenseId).subscribe((data)=>{
            if(!data.Error && data.DataObject!=null){
                this.LicenseActivationDetails=data.DataObject
            }
            this.isLoading=false;
        })
        
    }
    onSave(){
        if(this.selectedRow==null){
            Swal.fire({
                        title: "Please select atleast one license key",
                        showCloseButton:true,
                        showConfirmButton:true,
                        confirmButtonColor:'#FFCA28',
                        confirmButtonText:'OK',
            });
            return;
        }
        this.appLoader.open()
        let model={
            LicenseKey:this.SelectedLicenseKey,
            SCALType:this.SelectedCustomerLicenseDetail.SCALType,
            HardwareId:this.activateScal360LicenseForm.value.UniqueHardwareId,
            OSDetails:this.activateScal360LicenseForm.value.OSDetails,
            RequesterName:this.activateScal360LicenseForm.value.RequesterName,
            RequesterEmail:this.activateScal360LicenseForm.value.RequesterEmail,
            RequesterPhone:this.activateScal360LicenseForm.value.RequesterPhone,
            CreatedBy:Number(localStorage.getItem('userid')),
            UpdatedBy:Number(localStorage.getItem('userid'))
        }
        this.licenseService.activateScalLicense(model).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.scal360LicenseDisplayList=data.DataObject;
                this.dialogRef.close(this.scal360LicenseDisplayList);
                this.appLoader.close();
                this.snackBar.open("License activated successfully!","",{
                    duration:2000
                })
            }
            else{
                this.appLoader.close();
                this.dialogRef.close(this.scal360LicenseDisplayList);
            }
        })
    }
    onCancel(){
        this.dialogRef.close(this.scal360LicenseDisplayList);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/activate-scal360-license/activate-scal360-license.component.ts